"use client";

import { useRouter } from "next/navigation";
import styles from "./BackButton.module.scss";

export default function BackButton() {
  const router = useRouter();

  const handleGoBack = () => {
    router.back();
  };

  return (
    <button className={styles.button} onClick={handleGoBack}>
      <svg
        viewBox="0 0 17 12"
        fill="currentColor"
        width="18"
        height="100%"
        className={styles.button__icon}
      >
        <use href="/images/sprite.svg#arrow-2-left"></use>
      </svg>
    </button>
  );
}
